const getParams = (url: string, queryParams: string) => {
	let tempUrl = decodeURIComponent(url.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(queryParams).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
	return tempUrl;
}

const urlService = {
	getParams
}


export default urlService;